// Tier ladder for game access. Users and games both carry a tier; a user's
// tier must rank >= the game's required tier. Guests are implicitly 'standard'.
// Extend TIER_RANK when adding new tiers (e.g. 'beta', 'pro').
const TIER_RANK = {
    standard: 0,
    poppy: 100,
};
export function canAccess(userTier, requiredTier) {
    return TIER_RANK[userTier] >= TIER_RANK[requiredTier];
}
//# sourceMappingURL=gameAccess.js.map